/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { EvmTokenInfo } from './EvmTokenInfo';

export type EvmTokenListInfo = {
    TCNT: string;
    VCNT: string;
    TKNT: EvmTokenListInfo.TKNT;
    TKNLIST: Array<EvmTokenInfo>;
};

export namespace EvmTokenListInfo {

    export enum TKNT {
        NA = 'NA',
        CA = 'CA',
        ERC20 = 'ERC20',
        ERC721 = 'ERC721',
        ERC1155 = 'ERC1155',
    }


}

